module.exports = __webpack_public_path__ + "images/emoji/orange_book.5d0c97842a082ea5f2b4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/orange_book.png
// module id = 60ew
// module chunks = 14